export default __webpack_public_path__ + "static/media/pagination-usage.d760f75e.svg";